import React, { createContext, useContext } from 'react';

import { useRootStore } from '@/configs/store';
import { useLocalStore } from '@/hooks/useLocalStore';
import { useTimeLogStore } from '@/pages/TimesheetsPage/model';

import { DraftTimelogStore } from './DraftTimelogStore';

interface ProviderProps {
  children: React.ReactNode;
}

const DraftTimelogStoreContext = createContext<DraftTimelogStore | null>(null);

export const DraftTimelogProvider: React.FC<ProviderProps> = ({ children }) => {
  const { alertsStore } = useRootStore();
  const timeLogStore = useTimeLogStore();

  const draftTimelogStore = useLocalStore(
    () =>
      new DraftTimelogStore({
        timeLogStore,
        alertsStore,
      }),
  );

  return (
    <DraftTimelogStoreContext.Provider value={draftTimelogStore.store}>
      {children}
    </DraftTimelogStoreContext.Provider>
  );
};

export function useDraftTimelogStore() {
  const store = useContext(DraftTimelogStoreContext);

  if (!store) {
    throw new Error('useDraftTimelogStore must be used within DraftTimelogProvider');
  }

  return store;
}
